import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Popup from 'components/Popup';
import ReadMore from 'components/Buttons/ReadMore';

export default function FMVPopups({ isFMVPopupOpen, setIsFMVPopupOpen }) {
  const [isReadMorePopupOpen, setIsReadMorePopupOpen] = useState(false);

  const closeFMVPopup = () => setIsFMVPopupOpen(false);
  const closeReadMorePopup = () => setIsReadMorePopupOpen(false);

  const switchPopups = () => {
    closeFMVPopup();
    setIsReadMorePopupOpen(true);
  };

  return (
    <>
      {isFMVPopupOpen && (
        <Popup closePopup={closeFMVPopup}>
          <div className='mb-5'>
            <h2 className='mb-4'>What is a &quot;FMV&quot;?</h2>
            <p>A fair market value (FMV) is the appropriate price for a certain property, such as company stock.</p>
          </div>
          <div>
            <ReadMore onClick={switchPopups} />
          </div>
        </Popup>
      )}

      {isReadMorePopupOpen && (
        <Popup closePopup={closeReadMorePopup}>
          <h2 className='mb-4'>What is a &quot;FMV&quot;?</h2>
          <p>
            A fair market value (FMV) is the appropriate price for a certain property, such as company stock. The FMV can give employees an
            estimate of how much their options are worth at a given time. The person who determines fair market value could be one of two
            individuals: an independent appraiser or an employee of the company. The employee can determine FMV provided the company is
            still defined as a startup and they comply with 409A.
          </p>
        </Popup>
      )}
    </>
  );
}

FMVPopups.propTypes = {
  isFMVPopupOpen: PropTypes.bool,
  setIsFMVPopupOpen: PropTypes.func
};
